import { ArrowIcon, Card, Heading, Stack } from '@autoplan/web-ui'
import temporaryNews1 from '../../../public/temporary-news-1.png'

type NewsCardProps = {
  title: string
  introduction: string
  onClick: () => void
  imageSrc?: string
}

export const NewsCard = ({ title, introduction, onClick, imageSrc }: NewsCardProps) => {
  return (
    <Card className="ap:overflow-hidden" onClick={onClick}>
      <div className="ap:flex ap:h-[150px] ap:flex-row">
        <img src={imageSrc ?? temporaryNews1} alt={''} className="ap:h-full ap:w-1/3 ap:shrink-0 ap:object-cover" />
        <Stack spacing="xs" className="ap:p-2xl ap:w-2/3">
          <div className="ap:flex ap:justify-between">
            <Heading size="md">{title}</Heading>
            <ArrowIcon />
          </div>
          <p className="ap:pt-2xs ap:text-sm ap:text-content-secondary ap:overflow-hidden ap:text-ellipsis ap:[display:-webkit-box] ap:[-webkit-line-clamp:3] ap:[-webkit-box-orient:vertical]">
            {introduction}
          </p>
        </Stack>
      </div>
    </Card>
  )
}
